export class ToggleDeviceTestForRingingDevice {
   public static readonly type = '[SoundSettings] toggle device test for ringing device';

   constructor() {}
}

export class ToggleDeviceTestForOutputDevice {
   public static readonly type = '[SoundSettings] toggle device test for output device';

   constructor() {}
}

export class StartDeviceTestForInputDevice {
   public static readonly type = '[SoundSettings] toggle device test for input device';

   constructor() {}
}

export class StopAllDeviceTests {
   public static readonly type = '[SoundSettings] stop all device tests';

   constructor() {}
}

export class ToggleMuteMicrophoneAction {
   public static readonly type = '[SoundSettings] toggle mute device';

   constructor() {}
}
